<template>
  <div>
    <vx-card class="vx-col w-full mb-base m-auto">
      <vs-tabs position="top">
        <vs-tab label="Account">
          <table class="mt-5 billing-table">
            <tbody>
              <tr>
                <th>
                  <b>Subscription Plan :</b>
                </th>
                <th>
                  {{ plan_name }}
                  <span
                    class="ml-2"
                    v-bind:class="[(p_expiry==true)?'text-danger':'text-success']"
                  >({{ (p_expiry==true)?"Expired":"Active"}})</span>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Payment Term :</b>
                </th>
                <th>{{ plan_type }}</th>
              </tr>
              <tr>
                <th>
                  <b>Payment Method :</b>
                </th>
                <th>CC</th>
              </tr>
              <tr>
                <th>
                  <b>Account Balance :</b>
                </th>
                <th>{{ convertBalance(balance) }}</th>
              </tr>
              <tr>
                <th>
                  <b>Next Billing Cycle :</b>
                </th>
                <th>{{ plan_expiry | moment("DD-MM-YYYY") }}</th>
              </tr>
              <tr>
                <th>
                  <b>Plan Fee :</b>
                </th>
                <th>{{ plan_fee }}</th>
              </tr>
            </tbody>
          </table>
          <div class="mt-10">
            <h3 class="slider-head">Subscription Plans</h3>
            <!-- Pricing Tables -->
            <carousel class="pricing-tables m-4" :perPage="3" :navigationEnabled="true" :paginationSize="3">
              <!-- Plan Features -->
              <slide class="p-4" :key="index" v-for="(plan,index) in allSubscriptionPlan">
                <div class="pricing-plan featured-plan">
                  <div class="featured-ribbon" v-if="plan.stripe_quanterly_plan_id == user_info.stripe_plan_id || plan.stripe_year_plan_id == user_info.stripe_plan_id">Active</div>
                  <h2 class="plan-title">{{ plan.plan_name ? plan.plan_name : '-' }}</h2>
                  <ul class="plan-features">
                    <li><b>Up to {{ plan.no_of_users_allowed }}</b> Users</li>
                    <li><span></span></li>
                  </ul>
                  <vs-button class="w-full mt-5 p-4" type="filled"
                    :color="plan.stripe_quanterly_plan_id == user_info.stripe_plan_id && !user_info.is_plan_expire ? 'success' : 'primary'"  
                    :disabled="plan.stripe_quanterly_plan_id == user_info.stripe_plan_id && !user_info.is_plan_expire"
                    v-if="plan.stripe_quanterly_plan_id"
                    @click="confirmSubcription(plan.plan_name,plan.id,plan.stripe_quanterly_plan_id,plan.price_per_quarter,'Q')"
                  >
                    <strong>${{plan.price_per_quarter.toFixed(2)}} / Quarterly</strong>
                    <feather-icon class="ml-1 text-primary" icon="CheckCircleIcon" v-if="plan.stripe_quanterly_plan_id == user_info.stripe_plan_id"
                    ></feather-icon>
                  </vs-button>
                  <vs-button class="w-full mt-5 p-4" type="filled"
                    :color="plan.stripe_year_plan_id == user_info.stripe_plan_id && !user_info.is_plan_expire ? 'success' : 'primary'"
                    :disabled="plan.stripe_year_plan_id == user_info.stripe_plan_id && !user_info.is_plan_expire"
                    @click="confirmSubcription(plan.plan_name,plan.id,plan.stripe_year_plan_id,plan.price_per_year,'Y')"
                    v-if="plan.stripe_year_plan_id"
                  >
                    <strong>${{plan.price_per_year.toFixed(2)}} / Yearly</strong>
                    <feather-icon class="mt-1" icon="CheckCircleIcon" v-if="plan.stripe_year_plan_id == user_info.stripe_plan_id"
                    ></feather-icon>
                  </vs-button>
                  
                </div>
              </slide>
            </carousel>
          </div>
        </vs-tab>
        <vs-tab label="Billing History">
          <paymentHistory />
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import paymentHistory from "@/views/payment/list.vue";
import { Carousel, Slide } from 'vue-carousel';
import "@/assets/css/plan.css";
import { Card, createToken } from "vue-stripe-elements-plus";

export default {
  components: {
    Datepicker,
    paymentHistory,
    Carousel,
    Slide,
    Card
  },
  data() {
    return {
      p_expiry: "",
      plan_fee: "",
      plan_expiry: "",
      balance: "",
      plan_type: "",
      plan_name: "",
      popupActive1: false,
      complete: false,
      stripeOptions: {},
      stripe: process.env.VUE_APP_STRIPE_KEY,
      stripePrice: null,

      deleteIndex: 0,
      DataIndex: null,
      stripePlanID: null,
      planID: null,
      planPeriod: null,
      confirmPopup: false,
      remainingAmount: null,
      currentBalance: null,
      newPlanPrice: null,
      swiperOption: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 20,
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'fraction'
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // virtual: {
        //   slides: (function () {
        //     const slides = [];
        //     for (let i = 0; i < 600; i += 1) {
        //       slides.push('Slide ' + (i + 1))
        //     }
        //     return slides
        //   }())
        // },
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }
      },
      allSubscriptionPlan: [],
      sessionId: ""
    };
  },
  created() {},
  mounted() {
    this.getPlanInfo();
    this.getSubscriptionPlan();
  },
  computed:{
    user_info(){
      return this.$store.state.uInfo || null;
    }
  },
  methods: {
    convertBalance(balance) {
      let value = parseFloat(Math.abs(balance)) / 100;
      return value;
    },
    getPlanInfo() {
      this.p_expiry = this.$store.state.uInfo.is_plan_expire;
      this.plan_name = this.$store.state.uInfo.payment_plan.plan_name;
      this.plan_expiry = this.$store.state.uInfo.expiry_date;
      this.balance = this.$store.state.uInfo.balance;
      this.plan_type =
        this.$store.state.uInfo.payment_plan.stripe_year_plan_id ===
        this.$store.state.uInfo.stripe_plan_id
          ? "Yearly"
          : "Quarterly";
      this.plan_fee =
        this.$store.state.uInfo.payment_plan.stripe_year_plan_id ==
        this.$store.state.uInfo.stripe_plan_id
          ? this.$store.state.uInfo.payment_plan.price_per_year
          : this.$store.state.uInfo.payment_plan.price_per_quarter;
    },
    async getSubscriptionPlan() {
      this.$vs.loading({ color: "primary" });

      let url = "subcription/getAll";
      if (this.$store.state.uInfo.is_plan_expire == true) {
        url += "?is_active=true";
      }
      return await this.axios
        .get(url)
        .then(response => {
          if (response) {
            let data = response.data.data;
            // manage subscription plan
            let plan_arr = [];
            data.forEach(plan => {
              if (!plan.is_freeplan && this.user_info.payment_plan.is_freeplan && plan.is_active == true) {
                plan_arr.push(plan);
              }
              else if(!plan.is_freeplan && !this.user_info.payment_plan.is_freeplan && this.user_info.payment_plan.max_users <= plan.max_users && plan.is_active){
                plan_arr.push(plan);
              }
            });
            // check subscription plan and show in first potision
            /*for (let i = 0; i < plan_arr.length; i++) {
              if(plan_arr[i].id == this.user_info.payment_plan.id){
                plan_arr.splice(i, 1);
                plan_arr.unshift(plan_arr[i]);
              }
              
            } */           
            this.allSubscriptionPlan = plan_arr;
            this.$refs.mySwiper.swiper.slideTo(0, 0);
            this.$vs.loading.close();
            return true;
          }
        })
        .catch(e => {
          this.showError(e);
          return false;
        });
    },
    confirmSubcription(plan_name,plan_id, stripPlanid, price, period){
      this.stripePrice = price;
      this.stripePlanID = stripPlanid;
      this.planID = plan_id;
      this.planPeriod = period;
      let text = 'Are you sure you want to subscribe '+plan_name;
      if (period == 'Q') {
        text += ' (Quarterly)';
      }
      if (period == 'Y') {
        text += ' (Yearly)';
      }
      text += '.';
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirm Subcription`,
        text: text,
        acceptText: 'Pay $'+price,
        accept: this.subscribePlanInStripe
      });
    },
    subscribePlanInStripe() {
      let stripe = Stripe(this.stripe);
      this.$vs.loading({ color: "primary" });
      let input = {
        stripe_plan_id: this.stripePlanID,
        plan_id: this.planID,
        period: this.planPeriod,
        userId: this.$store.state.uInfo.id
      };
      this.axios
        .post('checkout',input)
        .then(response => {
          if (response) {
            let session_id = response.data.data.id;
            console.log(session_id);
            return stripe.redirectToCheckout({ sessionId: session_id });
          }
        })
        .catch(e => {
          this.showError(e);
        });
    },
    cancleConfirmPopup() {
      this.confirmPopup = false;
      this.remainingAmount = false;
      this.currentBalance = false;
      this.newPlanPrice = false;
    },
  }
};
</script>
<style>
.code-border {
  border: 1px solid;
}
</style>
<style lang="scss">
.carousel-example .swiper-container .swiper-slide {
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  background-color: #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 300px;
}
</style>
<style>
.swiper-slide .swiper-slide-active {
  width: 310px !important;
}
.pricing {
  width: 100%;
  text-align: center;
  border: 1px solid #e7e7e7;
  color: #251919;
  font-size: 16px;
  padding-left: 0;
  margin-bottom: 30px;
  font-family: "Lato";
  background: aliceblue;
  border-radius: 6px;
}
.pricing li {
  list-style: none;
  padding: 10px;
  font-size: 14px;
}
.pricing li + li {
  border-top: 1px solid #e7e7e7;
}
.pricing big {
  font-size: 20px;
}
.pricing h3 {
  margin-bottom: 0;
  font-size: 36px;
}
.pricing span {
  font-size: 12px;
  color: #999;
  font-weight: normal;
}

/* pricing color */
.p-green big,
.p-green h3 {
  color: #0057ff;
}

.pricing-table__button {
  display: block;
  background: #2049da;
  text-decoration: none;
  padding: 5px;
  color: #fff;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  width: 80%;
  margin: 5px auto;
  border-radius: 6px;
  font-size: 12px;
}

.pricing-table__button:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
  color: #fff;
  cursor: pointer;
}
.pricing-table__button:hover {
  box-shadow: 0px 0px 19px -3px rgba(0, 0, 0, 0.36);
}

.pricing-table__button:before {
  top: -80%;
  transform: rotate(0deg);
  width: 100%;
}
.pricing-table__button:after {
  opacity: 1;
  padding-right: 26px;
}
.slider-swiper {
  background: white !important;
}
.swiper-pagination-fraction {
  bottom: 0px !important;
}
.active-plan {
  background: #2049da;
  color: antiquewhite;
}
.not-active {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  font-size: 12px;
  color: #fff;
  background: gray;
}

.pricing span {
  color: #fff;
  font-weight: normal;
  padding: 0 0 0 7px;
  vertical-align: middle;
  width: 18%;
}
.pricing span svg {
  width: 30px;
  height: 30px;
}
</style>


